module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid py-2 my-2"
  }, [_c('div', {
    staticClass: "col-sm-12 row align-items-center"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_vm._m(0), _vm._v(" "), _c('date-picker-new', {
    attrs: {
      "enableClear": false,
      "range": true,
      "showFromTo": false
    },
    on: {
      "input": _vm.filterChanged
    },
    model: {
      value: (_vm.filters.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.filters, "dateRange", $$v)
      },
      expression: "filters.dateRange"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "glued-right"
  }, [_c('i', {
    staticClass: "ico ico-calendar fs-normal dark m-0"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-beccfd10", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-beccfd10"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Availability/Filters.vue
// module id = 2777
// module chunks = 0